import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Row } from "react-bootstrap";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { usePostHog } from "posthog-js/react";
import { formatSlug } from "../../../Utils/Regex";
import MembershipDetail from "../../../Common/membershipDetail/membershipDetail";

const PurchaseEventDetails = () => {
  const { state }: any = useLocation();
  const Navigate = useNavigate();
  const posthog = usePostHog();

  useEffect(() => {
    if (state?.data?.title) {
      posthog.capture(`[event-details]:${formatSlug(state?.data?.title)}`, {
        $set: { "last-event-details": formatSlug(state?.data?.title) },
      });
    }
  }, [state?.data?.title, posthog]);

  return (
    <div className="nonMember">
      <div className="default-plan">
        <Container fluid>
          <Row>
            <div className="col-lg-12 py-2">
              <div className="back-pg" onClick={() => Navigate(-1)}>
                <ArrowBackIosNewIcon />
                Back
              </div>
            </div>
          </Row>
          <MembershipDetail
            type="event"
            data={{
              ...state?.data,
              formData: state?.formData,
              amount: state?.data?.amount || state?.data?.price || 0,
            }}
          />
        </Container>
      </div>
    </div>
  );
};

export default PurchaseEventDetails;
